import { Box, Flex, Grid } from '@radix-ui/themes';
import { ErrorBoundary } from 'components/common/error-boundary';
import { SectionHeader } from 'components/sections/header';
import { PitchUploaderBody } from 'components/sections/pitch-uploader/body';
import { PitchUploaderNavigationBlocker } from 'components/sections/pitch-uploader/navigation-blocker';
import { PitchUploaderSidebar } from 'components/sections/pitch-uploader/sidebar';
import { t } from 'i18next';
import { RADIX } from 'lib_ts/enums/radix-ui';
import { useLocation, useNavigate } from 'react-router-dom';
import { NavLocationState } from 'routes/nav-state';
import { paths } from 'routes/paths';

export const PitchUploader = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const fromListId = (location.state as NavLocationState | null)?.fromListId;

  return (
    <ErrorBoundary identifier="PitchUploader">
      <PitchUploaderNavigationBlocker />
      <Flex direction="column" gap={RADIX.FLEX.GAP.SECTION}>
        <SectionHeader
          header={t('main.bulk-pitch-upload')}
          breadcrumbs={
            fromListId
              ? [
                  {
                    label: 'common.pitches',
                    onClick: () => navigate(paths.pitches.library),
                  },
                  {
                    label: 'common.pitch-list',
                    onClick: () => navigate(paths.pitches.list(fromListId)),
                  },
                  {
                    label: 'main.bulk-pitch-upload',
                  },
                ]
              : [
                  {
                    label: 'common.pitches',
                    onClick: () => navigate(paths.pitches.library),
                  },
                  {
                    label: 'main.bulk-pitch-upload',
                  },
                ]
          }
        />

        <Grid columns="4" gap={RADIX.FLEX.GAP.SIDEBAR}>
          <Box gridColumn="span 3">
            <PitchUploaderBody />
          </Box>
          <Box>
            <PitchUploaderSidebar />
          </Box>
        </Grid>
      </Flex>
    </ErrorBoundary>
  );
};
